import { Link, Outlet } from "react-router-dom";

import { InformationCircleIcon } from "@heroicons/react/solid";

const ApiDocumentation = () => {
  return (
    <div className="m-auto max-w-7xl mt-8 flex flex-wrap justify-start gap-2">
      <div className="max-w-[40rem] lg:mx-0 lg:max-w-none lg:flex-none px-4">
        <ul
          className="space-y-6 text-md leading-6 text-slate-700 lg:sticky lg:top-0 lg:-mt-16 lg:h-screen
lg:w-64 lg:overflow-y-auto lg:py-16 lg:pr-8
lg:[mask-image:linear-gradient(to_bottom,transparent,white_4rem,white)] lg:border-r border-gray-200"
        >
          <li>
            <a href="#getting-set-up" className="font-semibold text-slate-900">
              Introduction
            </a>
            <ul className="mt-4 space-y-2 border-l border-slate-200 pl-6">
              <li>
                <Link to="/shared/api-documentation/introduction/#getting-started">
                  Getting Started
                </Link>
              </li>
              <li>
                <Link to="/shared/api-documentation/introduction/#authentication">
                  Authentication
                </Link>
              </li>
            </ul>
          </li>

          <li>
            <a href="#using-react" className="font-semibold text-slate-900">
              Jobs
            </a>
            <ul className="mt-4 space-y-2 border-l border-slate-200 pl-6">
              <li>
                <Link to="/shared/api-documentation/create-job">
                  Create Job
                </Link>
              </li>
              <li>
                <Link to="/shared/api-documentation/job-details">
                  Job Details
                </Link>
              </li>
              <li>
                <Link to="/shared/api-documentation/job-comments">
                  Job Comments
                </Link>
              </li>
              <li>
                <Link to="/shared/api-documentation/job-price-breakdown">
                  Job Price Breakdown
                </Link>
              </li>
              <li>
                <Link to="/shared/api-documentation/job-photos">
                  Job Photos
                </Link>
              </li>
            </ul>
          </li>

          <li>
            <a href="#using-react" className="font-semibold text-slate-900">
              Resources
            </a>
            <ul className="mt-4 space-y-2 border-l border-slate-200 pl-6">
              <li>
                <Link to="/shared/api-documentation/services">Services</Link>
              </li>
              <li>
                <Link to="/shared/api-documentation/customer-services-by-name">
                  Customer Services
                </Link>
              </li>
              <li>
                <Link to="/shared/api-documentation/airports">Airports</Link>
              </li>
              <li>
                <Link to="/shared/api-documentation/fbos">FBOs</Link>
              </li>
            </ul>
          </li>

          {/* <li>
            <a href="#using-react" className="font-semibold text-slate-900">
              Stability
            </a>
            <ul className="mt-4 space-y-2 border-l border-slate-200 pl-6">
              <li>
                <Link to="/api-documentation/stability/test-runs">
                  Test Runs
                </Link>
              </li>
              <li>
                <Link to="/api-documentation/stability/add-results">
                  Add Result
                </Link>
              </li>
              <li>
                <Link to="/api-documentation/stability/tags">Tags</Link>
              </li>
            </ul>
          </li> */}
        </ul>
      </div>

      <Outlet />

      <div className="my-80"></div>
    </div>
  );
};

export default ApiDocumentation;
